const p="gift-card",c="boarderie:pending-gift-card",u="2025-10";const f=`
  mutation cartGiftCardCodesAdd($cartId: ID!, $giftCardCodes: [String!]!) {
    cartGiftCardCodesAdd(cartId: $cartId, giftCardCodes: $giftCardCodes) {
      cart {
        id
        appliedGiftCards {
          lastCharacters
          presentmentAmountUsed {
            amount
            currencyCode
          }
        }
      }
      userErrors {
        field
        message
      }
    }
  }
`,l=`
  query cartAppliedGiftCards($cartId: ID!) {
    cart(id: $cartId) {
      appliedGiftCards {
        lastCharacters
        presentmentAmountUsed {
          amount
          currencyCode
        }
      }
    }
  }
`;function C(r){return typeof r!="string"?"":r.replace(/\s+/g,"")}function w(r,t){const e=C(t);if(!e||!Array.isArray(r))return!1;const n=e.slice(-4).toLowerCase();return r.some(a=>{var o;return((o=a==null?void 0:a.lastCharacters)==null?void 0:o.toLowerCase())===n})}function A(){let r;try{r=window.localStorage.getItem(c)}catch{return null}if(!r)return null;let t;try{t=JSON.parse(r)}catch{return s(),null}return!(t!=null&&t.code)||!Number.isFinite(t.savedAt)||Date.now()-t.savedAt>2592e6?(s(),null):t}function I(r){try{window.localStorage.setItem(c,JSON.stringify(r))}catch{}}function s(){try{window.localStorage.removeItem(c)}catch{}}async function h(){const r=await fetch(`${window.Shopify.routes.root}cart.js`);if(!r.ok)throw new Error(`cart.js responded ${r.status}`);return r.json()}async function i(r,t){var a;const e=await fetch(`https://${window.Shopify.shop}/api/${u}/graphql.json`,{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({query:r,variables:t})});if(!e.ok)throw new Error(`Storefront API responded ${e.status}`);const n=await e.json();if((a=n==null?void 0:n.errors)!=null&&a.length)throw new Error(`Storefront API errors: ${n.errors.map(o=>o.message).join("; ")}`);return n==null?void 0:n.data}function d(r){return`gid://shopify/Cart/${r}`}async function g(r,t){const e=await i(f,{cartId:d(r),giftCardCodes:[t]}),n=e==null?void 0:e.cartGiftCardCodesAdd;if(!n)throw new Error("Storefront API returned no cartGiftCardCodesAdd payload");return n}async function y(r){var e;const t=await i(l,{cartId:d(r)});return((e=t==null?void 0:t.cart)==null?void 0:e.appliedGiftCards)||[]}function G(r){const t=Number.parseFloat(r==null?void 0:r.amount);if(!Number.isFinite(t)||!(r!=null&&r.currencyCode))return"";try{return new Intl.NumberFormat(void 0,{style:"currency",currency:r.currencyCode}).format(t)}catch{return`${t.toFixed(2)} ${r.currencyCode}`}}export{p as G,g as a,G as b,s as c,h as f,w as g,C as n,y as q,A as r,I as w};
//# sourceMappingURL=gift-card-utils.js.map
